module.exports = __webpack_public_path__ + "img/ep-fleur-1.8a169e3e.jpg";